const downloadFields = document.querySelectorAll(
	'.block-cta-download__download-field'
);

const downloadFile = (e) => {
	if (e.currentTarget.value) {
		window.open(e.currentTarget.value, '_blank');
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		if (downloadFields.length) {
			downloadFields.forEach((downloadField) => {
				downloadField.addEventListener('change', downloadFile);
			});
		}
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
